import { Spin, notification } from 'antd';
import { CircularProgress } from '@material-ui/core';

export const run = () => {
  Spin.setDefaultIndicator(<CircularProgress />);

  notification.config({
    placement: 'topRight',
    top: 72,
  });
};
